import { render, staticRenderFns } from "./brandFilterList.vue?vue&type=template&id=70d07460&scoped=true"
import script from "./brandFilterList.vue?vue&type=script&lang=js"
export * from "./brandFilterList.vue?vue&type=script&lang=js"
import style0 from "./brandFilterList.vue?vue&type=style&index=0&id=70d07460&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d07460",
  null
  
)

export default component.exports